module.exports = require('./dist/object/object.js');
